import { path } from 'ramda';

export const isCompletedSelector = path(['userActivity', 'isCompleted']);


// WEBPACK FOOTER //
// ./src/selectors/userActivitySelector.js